
	var commitDate = '20210217';
	var WinePrd = {
		pageRange:10,
		params:{
			searchType : "",
			pageNumber : 1,
			pageItemSize : 80,
			sortType : ""
		},
		init : function(){
			var params = this.getParams();
			params.pageNumber = 1;
			params.sortType = this.getSortType();
			WinePrd.loadPrdList();
			window.PageNavigationUtil.attachEvent(this.changeHash);
		},
		loadPrdList : function(){
			var $viewLoading = $("#viewLoading");
			var $prdList = $("#prd-list");
			var $delPrdArea = $("#prd-area");
			var $fragment = $(document.createDocumentFragment());	
			var addElement = "";		
			
			$delPrdArea.remove();
			$viewLoading.removeClass("none");
			
			var pageIndex = window.PageNavigationUtil.pageIdx || 1;
			var url = "/shop/wine/prdList.gs";
			if( document.location.hash ){
				var params = this.getParams();
			}else{
				var params = this.getDefaultParams();
			}
			params.pageNumber = pageIndex;

			$.ajax({
				url : url,
				cache : false,
				type : 'get',
				async : false,
				data:params,
				success : function(data) {
					addElement = data;
				}	
			});
			
			$viewLoading.after(addElement);
			var newTotalCnt = Number( $("#totalCnt").val() );
			if(isNaN(newTotalCnt)){
				newTotalCnt = 0;
			}
			$("#filter-sort .cnt").text(newTotalCnt.toLocaleString() + "개");
			newTotalCnt = (newTotalCnt == 0 ? 1 : newTotalCnt);
			window.PageNavigationUtil.init(pageIndex, params.pageItemSize, WinePrd.pageRange, newTotalCnt);
			$prdList.find("#prd-area").removeClass("none");
			$viewLoading.addClass("none");

			

		},
		changeHash : function(){
			jQuery(window).scrollTop(0);
			
			var pageHash = "";
			var params = WinePrd.getParams();
			params.pageNumber = window.PageNavigationUtil.pageIdx;
			pageHash += params.searchType + "|" + params.sortType + "|" + params.pageNumber;
		
			if (params.searchType == "SECT"){	// 카테고리
				pageHash += "|" + params.msectid + "|" + params.ssectid;
			} else if (params.searchType == "PLAN") {	// 기획전
				pageHash += "|" + params.planSeq;
				pageHash += "|" + params.planType;
			}
			document.location.hash = pageHash;
		},
		handleHash : function(){
			if( document.location.hash ){
				var hash = document.location.hash.substring(1);
				var hashArray = hash.split("|");
				var params = this.getParams();
				params.searchType = hashArray[0];
				params.sortType = hashArray[1];
				params.pageNumber = hashArray[2];
				if (hashArray[0] == 'SECT') {	// 카테고리
					params.msectid = hashArray[3]; 
					params.ssectid = hashArray[4];
				} else if (hashArray[0] == 'PLAN') {	// 기획전
					params.planSeq = hashArray[3];
					params.planType = hashArray[4];
				}
				$("input[name=sortType]").prop("checked",false);
				$("input[name=sortType][value="+params.sortType+"]").prop("checked",true);
				window.PageNavigationUtil.pageIdx = Number(params.pageNumber);
				
				WinePrd.loadPrdList();
			}		
		},
		setShopProduct:function(shopProductList){
			GsBase.entryData.shopProductList = shopProductList;
		},
		getSortType:function(){
			var sortTypeVal = $('[name=sortType]').filter(':checked').val();
			if ('undefined' == sortTypeVal || null == sortTypeVal) {
				sortTypeVal = "";
			}
			return sortTypeVal;
		},
		setParams:function(params){
			this.params = params;
		},
		getParams:function(){
			return this.params;
		},
		getDefaultParams:function(){
			this.params.sortType='DEFAULT';
			$("input[name=sortType]").prop("checked",false);
			$("input[name=sortType][value="+this.params.sortType+"]").prop("checked",true);
			return this.params;
		}
	};
	